import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { InstitutionGroup } from './InstitutionGroup';
import { GROUPS_I_AM_ADMIN_OF, GROUPS_I_AM_MEMBER_OF } from './SecurityRules';

export interface InstitutionGroupAttachmentRow {
  id: number;
  institution_group_id: number;
  title: string;
  attachment: string;
  created_at: string;
}

export const InstitutionGroupAttachment: Entity<InstitutionGroupAttachmentRow> = {
  id: 'InstitutionGroupAttachment',
  title: 'Institution Group Attachment',
  service: 'main',
  rowLabel: (row: InstitutionGroupAttachmentRow) => row.title,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_group_attachment',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: `institution_group_id IN ${GROUPS_I_AM_MEMBER_OF}`,
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `institution_group_id IN ${GROUPS_I_AM_ADMIN_OF}`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['title', 'ASC']],
  defaultFilters: [],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    institution_group_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Institution Group',
      refEntity: InstitutionGroup,
    },
    title: {
      seq: 15,
      label: 'Document Title',
      type: FieldType.Text,
      listColumn: true,
      mandatory: true,
      maxLength: 255,
    },
    attachment: {
      seq: 20,
      label: 'Attachment',
      type: FieldType.File,
      mandatory: true,
      listColumn: true,
    },
    created_at: {
      seq: 25,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
